
































import { Vue, Component, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";

// Enums/Data
import { DataModules } from "@/store/modules/data";

// Types
import { IAffiliateCommission } from "@/models/affiliate";
import { IClient } from "@/models/clients";
import { Location } from "vue-router";

@Component({
  computed: {
    ...mapGetters({
      isRejected: "data/affiliates/commissions/isRejected",
      isApproved: "data/affiliates/commissions/isApproved"
    })
  }
})
export default class PendingCommissionControl extends Vue {
  // Getters

  public isRejected!: Function;
  public isApproved!: Function;

  // Props

  @Prop({ required: true })
  public commission!: IAffiliateCommission;

  @Prop({ default: null })
  public clientId!: IClient["id"];

  // Computed

  public get canModifyCommission() {
    return (
      !this.isRejected(this.commission) && !this.isApproved(this.commission)
    );
  }

  // Methods

  public async manuallyApproveCommission() {
    this.$store.dispatch(
      `data/${DataModules.AFFILIATES_COMMISSIONS}/openApproveCommissionModal`,
      {
        amount: this.commission.amount_converted_formatted,
        brandName: this.commission.brand?.name,
        affiliateAccountId: this.commission.affiliate_account_id,
        invoiceIds: [this.commission.id],
        onSuccess: () => {
          this.$emit("reloadData");
        }
      }
    );
  }

  public rejectCommission() {
    this.$store.dispatch(
      `data/${DataModules.AFFILIATES_COMMISSIONS}/openRejectModal`,
      {
        parent: this,
        props: {
          affiliateAccountId: this.commission.affiliate_account_id,
          amount: this.commission.amount_converted_formatted,
          invoiceIds: [this.commission.id]
        },
        events: {
          success: () => {
            this.$emit("reloadData");
          }
        }
      }
    );
  }

  public get affiliateRoute(): Location {
    return {
      name: "adminClientAffiliateCommissions",
      params: {
        clientId: this.clientId
      }
    };
  }
}
